var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is.loaded)?_c('app-page',{attrs:{"title":_vm.page.title}},[_c('com-list')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }